import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleMediumFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const OmbudsmanSectionContainer = styled.section(({ theme }) => ({
  paddingTop: "40px",
  paddingBottom: "24px",
  marginBottom: "0 !important",
  borderBottom: `1px solid ${theme.color.line.medium}`,

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    gap: "40px",
  },
}));

export const OmbudsmanSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column-reverse",
  gap: "24px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
  },

  "p + p": {
    marginTop: "24px",
  },
}));

export const OmbudsmanSectionBlock = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const OmbudsmanSectionBlockTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleMediumFactory({ theme }),
}));

export const OmbudsmanSectionBlockDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),

  "button, a": {
    ...DefaultParagraphLargeFactory({ theme }),
    fontWeight: "600",
    color: theme.color.brandPrimary.light,
  },
}));

export const OmbudsmanSectionBlockImage = styled.img(() => ({
  maxWidth: "470px",
  width: "100%",
}));
